module.exports = __webpack_public_path__ + "static/the-long-tail-67f4e20c2a76c4774fd3884eb485b93b.jpg";